import {RequestApi} from "@/api/RequestApi";
import {UserApi} from "@/api/UserApi";
import {AuthenticationApi} from "@/api/AuthenticationApi";
import {ApiConfig, HttpClient} from "@/api/http-client";
import {FefcoCodeApi} from "@/api/FefcoCodeApi";
import {AdminApi} from "@/api/AdminApi";
import {QuoteApi} from "@/api/QuoteApi";
import {CartonGradeApi} from "@/api/CartonGradeApi";
import {OrderDataDocumentApi} from "@/api/OrderDataDocumentApi";
import {CompanyApi} from "@/api/CompanyApi";
import {AddressApi} from "./api/AddressApi";
import {ConfigApi} from "@/api/ConfigApi";
import {PlantApi} from "@/api/PlantApi";
import {CartonGradeImportApi} from "@/api/CartonGradeImportApi";
import {TenantApi} from "@/api/TenantApi";
import {OrderApi} from "@/api/OrderApi";
import {Reports} from "@/api/Reports";
import {LegalFormApi} from "@/api/LegalFormApi";
import {I18NText} from "@/api/I18NText";
// The generated client class is named `LegalDocuments` (plural, derived from `@Tag(name = "Legal
// Documents")`); aliased to `LegalDocumentApi` so it reads like the other `*Api` clients here.
import {LegalDocuments as LegalDocumentApi} from "@/api/LegalDocuments";
import {registerLangInterceptor} from "@/app/locale/apiLangInterceptor";
import {RequestFeedbackApi} from "@/api/RequestFeedbackApi";
import {TableViewStateApi} from "@/api/TableViewStateApi";

const apiConfig: ApiConfig = {
    baseURL: "/",
    withXSRFToken: true
};

export const authenticationApi = new AuthenticationApi(apiConfig);

export const addressApi = new AddressApi(apiConfig);

export const userApi = new UserApi(apiConfig);

export const requestApi = new RequestApi(apiConfig);

export const quoteApi = new QuoteApi(apiConfig);

export const fefcoCodeApi = new FefcoCodeApi(apiConfig);

export const cartonGradeApi = new CartonGradeApi(apiConfig);

export const orderDataDocumentApi = new OrderDataDocumentApi(apiConfig);

export const companyApi = new CompanyApi(apiConfig);

export const adminApi = new AdminApi(apiConfig);

export const configApi = new ConfigApi(apiConfig);

export const plantApi = new PlantApi(apiConfig);

export const cartonGradeImportApi = new CartonGradeImportApi(apiConfig);

export const tenantsApi = new TenantApi(apiConfig);

export const orderApi = new OrderApi(apiConfig);

export const reportsApi = new Reports(apiConfig);

export const legalFormApi = new LegalFormApi(apiConfig);

export const i18nTextApi = new I18NText(apiConfig);

// The legal-document client carries its language in the PATH (`/api/legal-documents/{document}/
// {language}`); the `lang` query param added by the interceptor below is not a second content signal —
// the backend reads it only for message localization. See `@/common/legal/legalDocuments`.
export const legalDocumentApi = new LegalDocumentApi(apiConfig);

export const requestFeedbackApi = new RequestFeedbackApi(apiConfig);

export const tableViewStateApi = new TableViewStateApi(apiConfig);

/**
 * Every exported Api instance above holds its own Axios `instance` (each generated client extends
 * `HttpClient`, see `@/api/http-client`) — the lang interceptor must be registered on each one
 * individually so anonymous backend calls (login failure, password-reset request, external order
 * tracking) carry the resolved anonymous language as a `lang` query param (see
 * `@/app/locale/apiLangInterceptor`). Authenticated calls are unaffected: `lang` already equals the
 * profile language for a logged-in user.
 */
const allApiInstances: HttpClient[] = [
    authenticationApi,
    addressApi,
    userApi,
    requestApi,
    quoteApi,
    fefcoCodeApi,
    cartonGradeApi,
    orderDataDocumentApi,
    companyApi,
    adminApi,
    configApi,
    plantApi,
    cartonGradeImportApi,
    tenantsApi,
    orderApi,
    reportsApi,
    legalFormApi,
    i18nTextApi,
    legalDocumentApi,
    requestFeedbackApi,
    tableViewStateApi
];
allApiInstances.forEach((api) => registerLangInterceptor(api.instance));
